module.exports = __webpack_public_path__ + "img/Berry.303c1863.svg";